import { render, staticRenderFns } from "./ShequDoctorAppDownload.vue?vue&type=template&id=52581a7a&scoped=true"
import script from "./ShequDoctorAppDownload.vue?vue&type=script&lang=js"
export * from "./ShequDoctorAppDownload.vue?vue&type=script&lang=js"
import style0 from "./ShequDoctorAppDownload.vue?vue&type=style&index=0&id=52581a7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52581a7a",
  null
  
)

export default component.exports